import type { FireIconProps } from './types';

export default function FireAlarmPull({ size = 24, color = 'currentColor', strokeWidth = 2, className, ...props }: FireIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className} {...props}>
      {/* Box */}
      <rect x="4" y="3" width="16" height="18" rx="2" />
      {/* Pull handle */}
      <rect x="8" y="13" width="8" height="4" rx="1" />
      {/* Handle grip line */}
      <line x1="10" y1="15" x2="14" y2="15" />
      {/* Arrow down */}
      <line x1="12" y1="17" x2="12" y2="19" />
      <polyline points="10 18 12 20 14 18" />
      {/* Text area (FIRE label) */}
      <line x1="8" y1="7" x2="16" y2="7" />
      <line x1="9" y1="9" x2="15" y2="9" />
    </svg>
  );
}
